import { render } from "./SloganText.vue?vue&type=template&id=bbce243a&scoped=true"
import script from "./SloganText.vue?vue&type=script&lang=js"
export * from "./SloganText.vue?vue&type=script&lang=js"

import "./SloganText.vue?vue&type=style&index=0&id=bbce243a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbce243a"]])

export default __exports__